(() => {
  if (window.PaxLumaExperienceLoaded) return;
  window.PaxLumaExperienceLoaded = true;
  const text = (element, value) => { if (element && element.textContent !== value) element.textContent = value; };
  const node = (tag, value, className) => { const element = document.createElement(tag); if (value) element.textContent = value; if (className) element.className = className; return element; };
  let active;

  class LumaPage {
    constructor(root) {
      this.root = root;
      this.config = JSON.parse(root.querySelector('[data-luma-config]').textContent);
      this.s = this.config.strings;
      this.optionCount = this.config.optionCount || 2;
      this.abort = new AbortController();
      this.options = { signal: this.abort.signal };
      this.chosen = new Set();
      root.querySelectorAll('variant-selects fieldset').forEach((field, index) => { if (field.querySelector('input:checked')) this.chosen.add(index); });
      this.guide = root.querySelector('.pax-luma-guide');
      this.sticky = root.querySelector('[data-luma-sticky]');
      this.mainButton = root.querySelector('[id^="ProductSubmitButton-"]');
      this.purchase = this.mainButton?.closest('product-form');
      this.root.addEventListener('click', event => this.guardPurchase(event), { ...this.options, capture: true });
      this.root.addEventListener('click', event => this.click(event), this.options);
      this.root.addEventListener('change', event => this.changed(event), { ...this.options, capture: true });
      this.root.addEventListener('submit', event => {
        if (!event.target.closest('product-form')) return;
        if (this.chosen.size < this.optionCount || this.selecting) { event.preventDefault(); event.stopImmediatePropagation(); this.focusSizes(); return; }
      }, { ...this.options, capture: true });
      this.variantSubscription = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.config.sectionId) return;
        this.selecting = false; clearTimeout(this.sizeTimer); text(this.root.querySelector('[data-luma-size-status]'), ''); this.sync();
      });
      window.addEventListener('section-store:cart:opened', () => this.finishPurchase(), this.options);
      window.addEventListener('section-store:cart:error', () => this.finishPurchase(this.s.drawer_error), this.options);
      this.guide.addEventListener('close', () => { this.syncSticky(); this.guideOpener?.focus({ preventScroll: true }); }, this.options);
      this.guide.addEventListener('click', event => { if (event.target === this.guide) { const r = this.guide.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.guide.close(); } }, this.options);
      this.guide.addEventListener('keydown', event => this.tabKeys(event), this.options);
      this.selectTab(this.config.piece === 'trousers' ? 'trousers' : 'top');
      this.selectUnit('in');
      this.observer = new MutationObserver(() => this.schedule());
      this.observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'data-is-render-option-set'] });
      this.intersection = new IntersectionObserver(([entry]) => { this.purchaseVisible = entry.isIntersecting; this.syncSticky(); }, { threshold: 0 });
      if (this.purchase) this.intersection.observe(this.purchase);
      this.sync();
    }
    schedule() { if (this.pending) return; this.pending = requestAnimationFrame(() => { this.pending = null; this.sync(); }); }
    click(event) {
      const trigger = event.target.closest('[data-luma-guide]');
      if (trigger) { this.guideOpener = trigger; this.selectTab(trigger.dataset.lumaGuide); this.guide.showModal(); this.syncSticky(); return; }
      if (event.target.closest('[data-luma-guide-close]')) { this.guide.close(); return; }
      const tab = event.target.closest('[data-guide-tab]'); if (tab) { this.selectTab(tab.dataset.guideTab); return; }
      const unit = event.target.closest('[data-guide-unit]'); if (unit) { this.selectUnit(unit.dataset.guideUnit); return; }
      if (event.target.closest('[data-luma-sticky-button]')) { this.stickyAction(); return; }
      if (event.target.closest('[data-luma-open-spares]')) {
        if (!window.SectionStoreCart?.getCart) return;
        event.preventDefault();
        const state = window.PaxLumaOfferRules.offerState(window.SectionStoreCart.getCart(), this.config);
        if (state.eligible) document.querySelector('a[href="/cart"]')?.click();
        else { text(this.root.querySelector('[data-luma-offer-status]'), this.s.offer_choose_first); this.focusSizes(); }
      }
    }
    changed(event) {
      if (!event.target.matches('variant-selects input,variant-selects select')) return;
      const field = event.target.closest('fieldset');
      const fields = Array.from(this.root.querySelectorAll('variant-selects fieldset'));
      if (field) this.chosen.add(fields.indexOf(field));
      const missing = fields.findIndex(item => !item.querySelector('input:checked'));
      if (missing !== -1) {
        event.stopImmediatePropagation();
        text(this.root.querySelector('[data-luma-size-status]'), missing === 0 ? this.s.choose_top : this.s.choose_trousers);
      } else {
        this.selecting = true;
        text(this.root.querySelector('[data-luma-size-status]'), this.s.checking_sizes);
        clearTimeout(this.sizeTimer);
        this.sizeTimer = setTimeout(() => text(this.root.querySelector('[data-luma-size-status]'), this.s.size_retry), 15000);
      }
      this.sync();
    }
    guardPurchase(event) {
      const buy = event.target.closest('[name="add"]');
      const notify = event.target.closest('#klaviyo-bis-button-container button,#klaviyo-bis-button-container a');
      if (!buy && !notify) return;
      if (this.chosen.size < this.optionCount || this.selected().some(value => !value)) {
        event.preventDefault(); event.stopImmediatePropagation();
        text(this.root.querySelector('[data-luma-size-status]'), this.chosen.has(0) ? this.s.choose_trousers : this.s.choose_top);
        this.focusSizes(); return;
      }
      if (notify) return;
      if (this.selecting || this.buyPending) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      if (this.buyUncertain) { event.preventDefault(); event.stopImmediatePropagation(); document.querySelector('a[href="/cart"]')?.click(); return; }
      if (this.root.querySelector('.pax-luma-embroidery input[type="checkbox"]:checked')) return;
      this.buyPending = true;
      this.purchaseMessage(this.s.purchase_adding);
      this.buyTimer = setTimeout(() => {
        this.buyPending = false; this.buyUncertain = true;
        this.purchaseMessage(this.s.purchase_uncertain, true); this.sync();
      }, 15000);
      this.schedule();
    }
    purchaseMessage(message, basket = false) {
      const status = this.root.querySelector('[data-luma-purchase-status]');
      text(status?.querySelector('span'), message || '');
      if (status?.querySelector('a')) status.querySelector('a').hidden = !basket;
    }
    finishPurchase(message = '') {
      clearTimeout(this.buyTimer); this.buyPending = false; this.buyUncertain = false;
      this.purchaseMessage(message); this.sync();
    }
    syncReviews() {
      const link = this.root.querySelector('.pax-luma-reviews-link');
      const badge = link?.querySelector('[data-number-of-reviews]');
      if (!badge) return;
      const label = this.s.review_link.replace('__COUNT__', badge.dataset.numberOfReviews).replace('__RATING__', badge.dataset.averageRating);
      if (link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
      link.querySelectorAll('.jdgm-prev-badge__stars').forEach(stars => { stars.removeAttribute('tabindex'); stars.removeAttribute('role'); stars.setAttribute('aria-hidden', 'true'); });
    }
    selectTab(name) {
      this.guide.querySelectorAll('[data-guide-tab]').forEach(button => { const selected = button.dataset.guideTab === name; button.setAttribute('aria-selected', String(selected)); button.tabIndex = selected ? 0 : -1; });
      this.guide.querySelectorAll('[data-guide-panel]').forEach(panel => { panel.hidden = panel.dataset.guidePanel !== name; });
    }
    selectUnit(unit) {
      this.guide.querySelectorAll('[data-guide-unit]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.guideUnit === unit)));
      this.guide.querySelectorAll('[data-unit]').forEach(span => { span.hidden = span.dataset.unit !== unit; });
      this.guide.querySelectorAll('[data-unit-caption]').forEach(span => text(span, unit));
    }
    tabKeys(event) {
      if (!event.target.matches('[data-guide-tab]') || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const tabs = Array.from(this.guide.querySelectorAll('[data-guide-tab]'));
      let index = tabs.indexOf(event.target);
      index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      this.selectTab(tabs[index].dataset.guideTab); tabs[index].focus();
    }
    sync() {
      this.mainButton = this.root.querySelector('[id^="ProductSubmitButton-"]');
      this.wrapEmbroidery(); this.syncReviews(); this.syncSticky();
      if (!this.mainButton || this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true') return;
      const label = this.buyUncertain ? this.s.check_basket : this.buyPending ? this.s.purchase_adding : this.chosen.size < this.optionCount ? this.s.sticky_choose : this.s.sticky_add;
      text(this.mainButton.querySelector('span'), label);
    }
    wrapEmbroidery() {
      const group = this.root.querySelector('.product-form__buttons');
      const wrapper = group?.querySelector('.tpo_option-set-wrapper');
      if (!group || !wrapper) return;
      let panel = group.querySelector('.pax-luma-embroidery');
      if (!panel) {
        panel = node('div', '', 'pax-luma-embroidery');
        panel.append(node('p', this.s.embroidery_terms, 'pax-luma-embroidery-terms')); group.prepend(panel);
      }
      if (wrapper.parentElement !== panel) panel.insertBefore(wrapper, panel.querySelector('.pax-luma-embroidery-terms'));
      panel.hidden = this.root.dataset.available === 'false' || Boolean(this.mainButton?.disabled);
    }
    selected() { return Array.from(this.root.querySelectorAll('variant-selects fieldset')).map(field => field.querySelector('input:checked')?.value || ''); }
    syncSticky() {
      if (!this.sticky) return;
      const choices = this.selected();
      const valid = choices.length === this.optionCount && choices.every(Boolean);
      const confirmed = this.chosen.size === this.optionCount;
      this.canAdd = valid && confirmed && !this.selecting && !this.buyPending && !this.mainButton?.disabled && this.mainButton?.getAttribute('aria-disabled') !== 'true';
      const soldOut = this.root.dataset.available === 'false' || this.mainButton?.disabled;
      const selection = this.sticky.querySelector('[data-luma-sticky-selection]');
      selection.hidden = !(valid && confirmed);
      text(selection, valid && confirmed ? this.s.sticky_selected.replace('__TOP__', choices[0]).replace('__TROUSERS__', choices[1]) : '');
      text(this.sticky.querySelector('[data-luma-sticky-button]'), !confirmed ? this.s.sticky_choose : this.selecting ? this.s.checking_sizes : this.buyPending ? this.s.purchase_adding : this.buyUncertain ? this.s.check_basket : soldOut ? this.s.sticky_notify : this.canAdd ? this.s.sticky_review : this.s.sticky_choose);
      this.sticky.hidden = this.purchaseVisible !== false || this.guide.open;
    }
    focusSizes() {
      const picker = this.root.querySelector('variant-selects');
      picker?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      const fields = Array.from(picker?.querySelectorAll('fieldset') || []);
      const field = fields.find((_, i) => !this.chosen.has(i)) || fields[0];
      field?.classList.add('pax-luma-size-attention'); (field?.querySelector('input:not(.disabled)') || field?.querySelector('input'))?.focus({ preventScroll: true });
      setTimeout(() => field?.classList.remove('pax-luma-size-attention'), 2000);
    }
    stickyAction() {
      if (this.chosen.size < this.optionCount) { this.focusSizes(); return; }
      if (this.selecting || this.buyPending) return;
      if (this.buyUncertain) { document.querySelector('a[href="/cart"]')?.click(); return; }
      if (this.root.dataset.available === 'false' || this.mainButton?.disabled) {
        const target = this.root.querySelector('#klaviyo-bis-button-container button,#klaviyo-bis-button-container a');
        if (target) { target.scrollIntoView({ block: 'center' }); target.focus({ preventScroll: true }); } else this.focusSizes();
      } else if (this.canAdd) {
        const target = this.root.querySelector('.pax-luma-embroidery input[type="checkbox"]:checked') || this.mainButton;
        target?.scrollIntoView({ block: 'center' }); target?.focus({ preventScroll: true });
      }
      else this.focusSizes();
    }
    destroy() { this.abort.abort(); clearTimeout(this.sizeTimer); clearTimeout(this.buyTimer); this.variantSubscription?.(); this.observer.disconnect(); this.intersection.disconnect(); if (this.pending) cancelAnimationFrame(this.pending); this.cart?.destroy(); }
  }

  function boot() { const root = document.querySelector('[data-pax-luma]'); if (!root || root === active?.root || !root.querySelector('[data-luma-config]') || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return; active?.destroy(); active = new LumaPage(root); }
  if (document.readyState === 'complete') boot(); else document.addEventListener('DOMContentLoaded', boot, { once: true });
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('product-info:loaded', boot);
})();

